import CategoryPage from './category-page'

export CategoryHero from './category-hero'
export * from './category-page'
export default CategoryPage
